/* New Canaan — horizontal slider affordance + product shelf tabs. Idempotent. */
(function () {
  if (window.__ncSlider) return;
  window.__ncSlider = true;

  function wireRail(rail) {
    if (rail.dataset.ncWired === 'true') return;
    rail.dataset.ncWired = 'true';

    var scroller = rail.previousElementSibling;
    while (scroller && scroller.nodeType !== 1) scroller = scroller.previousElementSibling;
    if (!scroller) return;

    var thumb = rail.querySelector('.rail__thumb');
    if (!thumb) return;

    var hint = rail.nextElementSibling;
    if (!hint || !hint.classList.contains('rail__hint')) hint = null;

    function update() {
      var overflow = scroller.scrollWidth - scroller.clientWidth;
      var scrollable = overflow > 4;
      rail.setAttribute('data-active', scrollable ? 'true' : 'false');
      if (hint) hint.style.display = scrollable ? '' : 'none';
      if (!scrollable) return;
      var ratio = scroller.clientWidth / scroller.scrollWidth;
      var w = Math.max(ratio * 100, 14);
      thumb.style.width = w + '%';
      var progress = scroller.scrollLeft / overflow;
      thumb.style.transform = 'translateX(' + (progress * (100 - w) / w * 100) + '%)';
      if (hint) hint.style.opacity = progress > 0.02 ? '0' : '';
    }

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 300);
    setTimeout(update, 1200);
  }

  function wireTabs(section) {
    if (section.dataset.ncTabs === 'true') return;
    section.dataset.ncTabs = 'true';

    var tabs = section.querySelectorAll('.shelf__tab');
    var panels = section.querySelectorAll('.shelf__panel');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) {
          if (i === j) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
        var rail = panels[i].querySelector('.rail');
        if (rail) window.dispatchEvent(new Event('resize'));
      });
    });
  }

  function wireArrows(section) {
    section.querySelectorAll('.shelf__arrow').forEach(function (btn) {
      if (btn.dataset.ncWired === 'true') return;
      btn.dataset.ncWired = 'true';
      btn.addEventListener('click', function () {
        var panel = section.querySelector('.shelf__panel:not([hidden])') || section;
        var track = panel.querySelector('.shelf__track');
        if (!track) return;
        var dir = Number(btn.getAttribute('data-dir')) || 1;
        var card = track.querySelector('.pcard');
        var step = card ? card.getBoundingClientRect().width + 12 : 240;
        track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      });
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.rail').forEach(wireRail);
    scope.querySelectorAll('[data-nc-shelf]').forEach(function (s) { wireTabs(s); wireArrows(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
